import { render } from "./TariffsChange.vue?vue&type=template&id=7a074035&scoped=true"
import script from "./TariffsChange.vue?vue&type=script&lang=js"
export * from "./TariffsChange.vue?vue&type=script&lang=js"

import "./TariffsChange.vue?vue&type=style&index=0&id=7a074035&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a074035"]])

export default __exports__